module.exports = __webpack_public_path__ + "static/media/icon-id-card-blue.6ea3477f.svg";